import { z } from 'zod'

export const zProductWebshopStatusEnum = z.enum([
  'COMPOSABLE_A',
  'COMPOSABLE_B',
  'COMPOSABLE_C',
  'COMPOSABLE_D',
  'COMPOSABLE_E',
  'COMPOSABLE_F',
  'COMPOSABLE_G',
  'NO',
])

export type ProductWebshopStatusEnumSchema = z.infer<typeof zProductWebshopStatusEnum>

export const ProductWebshopStatusEnum = zProductWebshopStatusEnum.enum
